import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/NotFound.css';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <div className="notfound-animation">
          <span className="notfound-emoji">🔍</span>
          <h1 className="notfound-title">404</h1>
        </div>
        
        <h2 className="notfound-subtitle">
          {t ? t('notfound.title') : 'Page introuvable'}
        </h2>
        
        <p className="notfound-description">
          {t ? t('notfound.description') : 'Désolé, la page que vous cherchez n\'existe pas ou a été déplacée.'}
        </p>

        <div className="notfound-actions">
          <Link to="/" className="notfound-btn primary">
            <span>🏠</span>
            {t ? t('notfound.home') : 'Retour à l\'accueil'}
          </Link>
          <Link to="/contact-client" className="notfound-btn secondary">
            <span>💼</span>
            {t ? t('notfound.contact') : 'Me contacter'}
          </Link>
        </div>

        <div className="notfound-suggestions">
          <p className="suggestions-title">
            {t ? t('notfound.suggestions') : 'Pages populaires :'}
          </p>
          <div className="suggestions-links">
            <Link to="/">Accueil</Link>
            <span>•</span>
            <Link to="/contact-client">Projet</Link>
            <span>•</span>
            <Link to="/contact-entreprise">Recrutement</Link>
          </div>
        </div>
      </div>

      <div className="notfound-decoration">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
      </div>
    </div>
  );
};

export default NotFound;